module.exports = __webpack_public_path__ + "img/DXTrade-white.c052f250.png";